import React, { useState } from 'react';
import AdminLogin from './AdminLogin';
import AdminPanel from './AdminPanel';

const Admin = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  return (
    <div>
      {isLoggedIn ? <AdminPanel /> : <AdminLogin onLogin={() => setIsLoggedIn(true)} />}
    </div>
  );
};

export default Admin;
